export type MarkeLogoCandidate = {
  source: 'media_library' | 'logo_dev' | 'open_beauty_facts';
  previewUrl: string;
  storageKey?: string;
  remoteImageUrl?: string;
  confidence: number;
  reason: string;
  brandName: string;
  markeId?: string | null;
  markeSlug?: string | null;
};

export type ImportPendingLogoSuggestion = {
  markeSlug: string;
  markeName: string | null;
  markeId: string | null;
  candidate: MarkeLogoCandidate;
};

export type AcceptedMarkeLogoAttachment = {
  markeSlug: string;
  source: MarkeLogoCandidate['source'];
  storageKey?: string;
  remoteImageUrl?: string;
};

export function candidateToAttachment(
  markeSlug: string,
  candidate: MarkeLogoCandidate,
): AcceptedMarkeLogoAttachment {
  return {
    markeSlug,
    source: candidate.source,
    storageKey: candidate.storageKey,
    remoteImageUrl: candidate.remoteImageUrl,
  };
}

export function markeLogoSourceLabel(source: MarkeLogoCandidate['source']): string {
  if (source === 'media_library') return 'Médiathèque';
  if (source === 'logo_dev') return 'Logo.dev';
  return 'Open Beauty Facts';
}
